import React from 'react';
import PropTypes from 'prop-types';
import Constants from "../util/Constants";

const FormLayout = props =>
    <div className="mt-3 mb-5">
        <div className="row justify-content-center align-top">
            <img src={Constants.LOGO_URL} alt="Doltcini Logo"/>
        </div>

        <div className="row justify-content-center align-items-center">
            <div className="col-xs-12 col-md-6 col-lg-3">
                <h3 className="mt-4">{props.title}</h3>
                {props.children}
            </div>
        </div>
    </div>;

FormLayout.propTypes = {
    title: PropTypes.string.isRequired,
};
export default FormLayout;